export default __webpack_public_path__ + "ee31e8e91ed7528027cecb83538a9fd2.png";